/* eslint-disable */
import * as React from "react";
import { SelectField, Button, Flex, Grid, TextField } from "@aws-amplify/ui-react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Player, Friends } from "../models";
import { fetchByPath, validateField } from "./utils";
import { DataStore, Auth } from "aws-amplify";
import ListComponent from "./ListComponent";
import { useNavigate, useLocation } from "react-router-dom";
import { createActiveGame } from "../lib/activeGameService";

export default function GameSetup(props) {
    const {
        clearOnSuccess = true,
        onSuccess,
        onError,
        onSubmit,
        onValidate,
        onChange,
        overrides,
        ...rest
      } = props;
      const [errors, setErrors] = React.useState({});

    const navigate= useNavigate();
    const location = useLocation();
    console.log(location.state.game)
    const game = location.state.game
    const [currentSelectedPlayer, setCurrentSelectedPlayer] = React.useState("");
    const [friendMap, setFriendMap] = React.useState(new Map());
    const [initialDealer, setInitialDealer] = React.useState("");

    const [PlayerList, setPlayerList] = React.useState([]);
    const [FriendList, setFriendList] = React.useState("");
    React.useEffect(()=>{
        console.log("effect")
        getFriends()
    },[]);
    
    async function getFriends() {
        getOwner().then(o => {
            console.log(o)
            DataStore.query(Friends, f => f.FriendOf.eq(o)).then(friends => {
                const newFriendMap = new Map();
                friends?.forEach((item) => {
                    newFriendMap.set(item.id, item.Name);
                });
                setFriendMap(newFriendMap);
                setFriendList(Array.from(newFriendMap.entries()).map(([id, name]) => (
                    <option value={id} key={id}>{name}</option>
                )));
                console.log("initial selection: ",friends[0]?.id)
                setCurrentSelectedPlayer(friends[0]?.id); 
            });
        });
    }
    
    async function getOwner() {
        //override who it belongs to
        let user = await Auth.currentAuthenticatedUser();
        console.log("friendOf: ", user.username);
        return user.username;
    }
    
    return (
        <Grid
            as="form"
            rowGap="15px"
            columnGap="15px"
            padding="20px"
            onSubmit={async (event) => {
                event.preventDefault();
                let players = []
                for (const p of PlayerList) {
                    console.log("Processing: ", p)
                    let modelFields = {
                        Name: p.props.value,
                        gameID: game.id
                    };
                    
                    try {
                        console.log("Saving: ", modelFields)
                        Object.entries(modelFields).forEach(([key, value]) => {
                            if (typeof value === "string" && value.trim() === "") {
                                modelFields[key] = undefined;
                            }
                        });
                        let player= new Player(modelFields)
                        const savedPlayer = await DataStore.save(player);
                        players.push(savedPlayer)
                        
                    } catch (err) {
                        if (onError) {
                            onError(modelFields, err.message);
                        }
                    }
                }
                // create active game snapshot for resume
                try {
                    const now = new Date();
                    const displayName = `${game.name || 'Game'} - ${now.toLocaleString()}`;
                    const snapshotPlayers = players.map(p => ({ id: p.id, Name: p.Name }));
                    console.log("[Grass resume] creating snapshot:", {
                        activePlayers: snapshotPlayers,
                        initialDealer,
                        completedRounds: []
                    });
                    const activeId = createActiveGame({
                        gameType: 'GRASS',
                        displayName,
                        players: snapshotPlayers,
                        snapshot: { players: snapshotPlayers, initialDealer, currentRound: 1, completedRounds: [] },
                        route: '/gameplay'
                    });
                    navigate("/gameplay", { state: { game: game, players: players, initialDealer, activeGameId: activeId }  });
                } catch (e) {
                    navigate("/gameplay", { state: { game: game, players: players, initialDealer }  });
                }
            }}
            {...getOverrideProps(overrides, "GameSetup")}
            {...rest}
        >
            <SelectField
                label="Players"
                descriptiveText="Select Player, then press 'Add Player'"
                onChange={(e) => {  
                                    console.log("Selected:", e); 
                                    setCurrentSelectedPlayer(e.target.value); 
                                }}
            >
                { FriendList }

            </SelectField>
        <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Add Player"
          onClick={(event) => {
            event.preventDefault();
            console.log("add Player, selected: ", currentSelectedPlayer, " : ", friendMap.get(currentSelectedPlayer));
            let name= friendMap.get(currentSelectedPlayer)
            if(name) {
                let newList= [...PlayerList]
                newList.push(<li key={currentSelectedPlayer} value={friendMap.get(currentSelectedPlayer)}>{friendMap.get(currentSelectedPlayer)}</li>);
                setPlayerList(newList)
                if (!initialDealer) {
                    setInitialDealer(name);
                }
                const newFriendMap = new Map(friendMap);
                newFriendMap.delete(currentSelectedPlayer);
                setFriendMap(newFriendMap);
                setFriendList(Array.from(newFriendMap.entries()).map(([id, playerName]) => (
                    <option value={id} key={id}>{playerName}</option>
                )));
                const nextPlayerId = newFriendMap.keys().next().value;
                setCurrentSelectedPlayer(nextPlayerId || "");
            } 
          }}
          {...getOverrideProps(overrides, "AddPlayerButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        ></Flex>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Start Game"
                        className="start-game-button"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
      <ListComponent items={PlayerList}/>
            {PlayerList.length > 0 && (
                <SelectField
                    label="Initial Dealer"
                    descriptiveText="Select who should deal the first round"
                    value={initialDealer}
                    onChange={(event) => setInitialDealer(event.target.value)}
                >
                    {PlayerList.map((player) => (
                        <option key={player.key} value={player.props.value}>
                            {player.props.value}
                        </option>
                    ))}
                </SelectField>
            )}
        </Grid>
    );
}
